import React, { useState, useCallback } from 'react';
import hannaShy from '../assets/Q9/hanna_shy.jpg';

const MIN_NO_SCALE = 0.12;
const SCALE_DECAY = 0.88;

function Q9({ question = 9, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  const [escaping, setEscaping] = useState(false);
  const [noPosition, setNoPosition] = useState({ x: 60, y: 45 });
  const [noScale, setNoScale] = useState(1);
  const noClickable = noScale > MIN_NO_SCALE;

  const moveAndShrink = useCallback(() => {
    setNoPosition({
      x: 10 + Math.random() * 80,
      y: 15 + Math.random() * 70
    });
    setNoScale(s => Math.max(MIN_NO_SCALE, s * SCALE_DECAY));
  }, []);

  const handleFirstNoClick = useCallback(() => {
    setEscaping(true);
    setNoPosition({
      x: 10 + Math.random() * 80,
      y: 15 + Math.random() * 70
    });
    setNoScale(SCALE_DECAY);
  }, []);

  const handleNoClick = useCallback(() => {
    moveAndShrink();
  }, [moveAndShrink]);

  return (
    <div className="dashboard q9__dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm a witty title</span>
        <h1>Project Valen</h1>
        <p>Tip: Act like Genevieve</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q2__center q9__center">
      <span className="secretpin__title q2__greeting">Are you blushing?</span>
      <div className={`q9__buttons${escaping && !noClickable ? ' q9__buttons--centered' : ''}`}>
        <button
          type="button"
          className="dashboard__button dashboard__button--primary home__button q2__wave-button"
          onClick={() => onNavigate?.('q10')}
        >
          {escaping && !noClickable ? 'Yes... fine! I\'ll admit it!' : 'Yes'}
        </button>
        {!escaping ? (
          <button
            type="button"
            className="dashboard__button dashboard__button--primary home__button q2__wave-button"
            onClick={handleFirstNoClick}
          >
            No!
          </button>
        ) : (
          <>
            {noClickable && (
              <button
                type="button"
                className="dashboard__button dashboard__button--primary home__button q2__wave-button q9__no-spacer"
                aria-hidden="true"
                tabIndex={-1}
                disabled
              >
                No!
              </button>
            )}
            {noClickable && (
              <button
                type="button"
                className="dashboard__button dashboard__button--primary home__button q2__wave-button q9__no-button"
                style={{
                  position: 'absolute',
                  left: `${noPosition.x}%`,
                  top: `${noPosition.y}%`,
                  transform: 'translate(-50%, -50%) scale(' + noScale + ')',
                  transition: 'transform 0.15s ease-out, left 0.15s ease-out, top 0.15s ease-out'
                }}
                onClick={handleNoClick}
              >
                No!
              </button>
            )}
          </>
        )}
      </div>
      <img src={hannaShy} alt="" className="q2__gif" />
    </div>
  </div>
  );
}

export default Q9;
